import PayerPage from './PayerPage'

export default PayerPage
